export default __webpack_public_path__ + "static/media/nextDate.09109e1e.svg";